<template>
  <div id="app">
    <Wkd search-domain="immerda.ch"/>
  </div>
</template>

<script>
import Wkd from "./components/Wkd";

export default {
  name: 'app',
  components: {
    Wkd,
  }
}
</script>

<style>
#app {
  font-size: 16px;
}
</style>
